import React from 'react';

import NeoLayout from './neoLayout';

import { useTranslation } from 'react-i18next';

export default function Http404() {
    const { t } = useTranslation();
	return (
        <NeoLayout>
            <NeoLayout.Header config={{title: t('widget.404.title')}}/>
            <NeoLayout.Subtitle config={{subtitle: t('widget.404.subtitle')}}/>
        </NeoLayout>
	);
}
